import { useViewModel } from '@/lib/viewModels'
import { ProductListViewModel } from '../viewModels/ProductListViewModel'
import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import { useStores } from '@/hooks/useStores'
import { ProductStoreType } from '../stores/ProductModel'

import React from 'react'
import { useRouter } from 'next/router'
import { themeGet } from '@styled-system/theme-get'
import { SearchResultHeader } from '../components/SearchResultHeader'
import { Col, Row } from 'antd'
import { SearchResultFilter } from '../components/SearchResultFilter'
import { DefaultLoadingContainer } from '@/components/DefaultLoadingContainer'
import { ProductUnifiedSearchResult } from '../components/ProductUnifiedSearchResult'
import { GenericPanelCloseIcon, GenericPanelWithModal } from '@/components/GenericPanel'
import { ProductFilterBox } from '../components/ProductFilterBox'

export interface ProductListViewProps {}

export const ProductListViewWrapper = styled.div`
	& > .ant-row {
		@media (max-width: 1200px) {
			display: block;
			margin: 0 -16px !important;
		}
		@media (max-width: 768px) {
		}

		.ant-col {
			&.filter-box {
				@media (max-width: 1200px) {
					display: none;
					position: fixed;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					flex: unset;
					width: 100vw;
					max-width: 100vw;
					padding: 0 !important;
					background-color: #fff;
					z-index: 3000;

					&.show {
						display: block;
					}
				}
				@media (max-width: 768px) {
				}
			}

			&.result-box {
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				@media (max-width: 1200px) {
					flex: unset;
					max-width: 100vw;
					width: 100vw;
					padding: 0 !important;
				}
				@media (max-width: 768px) {
				}
			}
		}
	}
`

export const SearchCurrentFilter = styled.div`
	display: flex;
	align-items: center;
	justify-content: start;
	min-height: 48px;
	padding: 4px 0 12px;
	margin-bottom: 22px;
	background-color: ${themeGet('background.0', '#FDFDFF')};
	border-bottom: 1px solid ${themeGet('border.1', '#E8E8EA')};

	@media (max-width: 1200px) {
		padding: 8px 24px;
		margin-top: -24px;
	}
	@media (max-width: 768px) {
		padding: 8px 16px;
		margin-top: 0;
	}

	.text {
		font-size: 16px;
		margin-right: 16px;

		&.w {
			min-width: 88px;
		}

		&.m {
			display: none;
			margin-right: 0;

			.ant-btn {
				padding: 0 16px;
				margin-left: -16px;
				border: none;
				background-color: transparent;
			}
		}

		@media (max-width: 1200px) {
			&.w {
				display: none;
			}
			&.m {
				display: block;
			}
		}
		@media (max-width: 768px) {
			&.m {
				min-width: 50px;
			}
		}

		img {
		}
	}

	.current-filter-area {
		display: flex;
		gap: 8px;
		flex-wrap: wrap;

		.ant-btn {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 8px;
			box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.03) !important;

			span {
				font-size: 14px;
				font-weight: 600;
				color: rgba(27, 27, 27, 0.7);
				margin-right: 2px;
			}
		}
	}
`

export const ProductListView: React.FC<ProductListViewProps> = observer((props) => {
	const productStore = useStores() as ProductStoreType
	const router = useRouter()
	const { status, actions } = useViewModel(
		{ rootStore: productStore, router },
		ProductListViewModel,
	)
	return (
		<>
			{!status.initialized && <DefaultLoadingContainer title="데이터를 불러오는 중입니다." />}
			{status.initialized && (
				<ProductListViewWrapper>
					<SearchResultHeader
						keyword={actions.keyword}
						total={actions.items.length}
						onCart={actions.onCart}
					/>
					<Row gutter={72}>
						<Col
							span={6}
							className={status.showFilter ? 'filter-box show' : 'filter-box'}>
							<SearchResultFilter
								dataSource={actions.currentFilters}
								category={actions.category}
								onShowModal={actions.onShowModal}
								onShowMobileFilter={actions.onShowMobileFilter}
								onReset={actions.onResetFilter}
								selectedItems={actions.currentSelectedFilters}
								onChangeFilterItems={actions.onChangeFilterItems}
								deleteItem={status.deleteFilterItem}
							/>
						</Col>
						<Col span={18} className={'result-box'}>
							{status.loading ? (
								<DefaultLoadingContainer title="데이터를 불러오는 중입니다." />
							) : (
								<ProductUnifiedSearchResult
									onPriceChange={actions.onPriceChange}
									keywords={actions.keyword}
									onItemClick={actions.onItemClick}
									onEmptyClick={actions.onEmptyClick}
								/>
							)}

							<GenericPanelWithModal
								title={`단원/UNIT`}
								closeIcon
								okText="확인"
								open={status.showModal}
								cancelText="초기화"
								onClose={() => actions.onShowModal(null, null)}
								onOk={() => actions.onShowModal(null, null)}>
								<ProductFilterBox
									idx={status.currentModalIdx}
									filterItems={actions.currentSelectedFilters}
									currentSelectedInBox={status.currentSelectedInBox}
									updateFilterItem={actions.onChangeFilterItems}
									deleteItem={status.deleteFilterItem}
								/>
							</GenericPanelWithModal>
						</Col>
					</Row>
				</ProductListViewWrapper>
			)}
		</>
	)
})
